// Product card badges map
export const badgesMap: Record<string, string> = {
  'label.badge-customize-only': 'Custom Made Only',
  'label.badge-essential': 'Essential',
  'label.badge-final-sale': 'Final sale',
  'label.badge-for-jackets-only': 'For Jackets Only',
  'label.badge-full-canvas': 'Full Canvas',
  'label.badge-half-canvas': 'Half Canvas',
  'label.badge-lightest-suit': "The World's Lightest Suit",
  'label.badge-limited': 'Limited',
  'label.badge-mix-match': 'Mix & Match',
  'label.badge-online-exclusive': 'Online Exclusive',
  'label.badge-preorder': 'Pre-order',
  'label.badge-shop-the-look': 'Shop The Look',
  'label.badge-unconstructed': 'Unconstructed',
  'label.badge-world-lightest-suit': "The World's Lightest Suit",
}

export const CUSTOMIZE_ICON =
  'https://cdn.suitsupply.com/image/upload/f_auto/q_auto/v1614243045/svg/icon-cm-big.svg'
